import {
  FormControlLabel,
  FormHelperText,
  IconButton,
  TextField,
  Typography
} from "@material-ui/core";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useTheme } from "@material-ui/styles";
import AddRowButton from "components/common/AddRowButton";
import ContentTitle from "components/common/ContentTitle";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  TableRowHead,
  UploadButton,
  useStyles
} from "components/request-document/components/Commons";
import { useExtendsionFormPartE } from "components/smart-visa-extension/useExtendsionForm";
import useModalLoading from "libs/hooks/useModalLoading";
import { openFileById } from "libs/utils/file";
import {
  defaultStakeholders,
  getErrorMessage,
  mapStakeholders
} from "libs/utils/form";
import { get, isError } from "lodash-es";
import React from "react";
import { useSelector } from "react-redux";
import { selectMasterData } from "redux/modules/masterSlice";
import FileService from "services/FileService";


function sortByName(fileName) {
  return (a, b) => {
    const nameA = a[fileName]?.toUpperCase(); // ignore upper and lowercase
    const nameB = b[fileName]?.toUpperCase(); // ignore upper and lowercase

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  };
}

export default function PartE() {
  const classes = useStyles();
  const theme = useTheme();
  const { showLoading, hideLoading } = useModalLoading();
  const { formik, onSaveDraft } = useExtendsionFormPartE();

  const masterData = useSelector(selectMasterData);
  const companyprogressConfig =
    get(masterData, "companyprogressConfig", []) || [];

  const Stakeholders = formik.values.stakeholders || [];

  const configField = [
    { number: 3, title: "Product development progress", subTitle: "(e.g., prototype designing or development of your product or service, demo, minimal viable product, mockup product)", fieldName: "ProductDev" },
    { number: 4, title: "Customer testimonial", fieldName: "CustomerTest" },
    { number: 5, title: "Company structural progress", subTitle: "Provide evidence of your company’s legal procedures (e.g., Certificate of incorporation, required licenses, permits)", fieldName: "CompanyStr" },
    { number: 6, title: "Technical development progress", subTitle: "(e.g., platform)", fieldName: "TechnicalDev" },
    { number: 7, title: "Agencies you developed a partnership with", subTitle: "Provide evidence showing a partnership between your business and agency.", fieldName: "AgenciesYou" },
    { number: 8, title: "Human resources development progress", subTitle: "Describe courses or training you provided, new employees hired, or any activities related.", fieldName: "HumanRes" },
    { number: 9, title: "Updated business timeline", subTitle: "Including what milestones you have achieved, your present activity, and your future business plan", fieldName: "UpdatedBus" },
    { number: 10, title: "Updated financial plan (if any)", fieldName: "UpdatedFin" },
    { number: 11, title: "Updated marketing plan (if any)", fieldName: "UpdatedMark" },
    { number: 12, title: "Difficulties", subTitle: "Please describe problems encountered in doing business.", fieldName: "Difficulties" },
  ]

  return (
    <div className={classes.root}>
      <ContentTitle
        title="APPLICATION FOR SMART VISA EXTENSION"
        subTitle="SMART VISA EXTENSION"
      />
      <form onSubmit={formik.handleSubmit}>
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={5}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part E : Business progress
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <StyledTableCell colSpan={5}>
                  <div className={classes.cellContent}>
                    <Bagde number={1} />
                    <div className={classes.wrapField}>
                      <InputLabel>Company registration progress</InputLabel>
                      <FormGroup>
                        <div className={classes.flexRow}>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                name="Companyprogress"
                                checked={
                                  formik.values?.Companyprogress === true || formik.values?.Companyprogress === 'True'
                                }
                                onClick={() => {
                                  formik.setFieldValue(
                                    "Companyprogress",
                                    !formik.values?.Companyprogress
                                  );
                                }}
                              />

                            }
                            style={{ display: 'flex', flex: 1 }}
                            label={"1.Having registered the memorandum of association"}
                          />
                          <UploadButton
                            title="Upload document"
                            id="Upload document"
                            disabled={formik.values?.Companyprogress !== true && formik.values?.Companyprogress !== 'True'}
                            onChange={async (event) => {
                              try {
                                showLoading()
                                const response = await FileService.uploadFile({
                                  file: event.target.files[0],
                                  Status: true,
                                });
                                const fileId = response.results?.fileID;
                                formik.setFieldValue(`CompanyprogressDetail`, fileId);
                              } catch (error) {
                                console.log("Upload error", error);
                              } finally {
                                hideLoading()
                              }
                            }} />
                          {get(formik.values, `CompanyprogressDetail`, "") && (
                            <IconButton
                              style={{ width: 40 }}
                              size="small"
                              onClick={async () => {
                                openFileById(formik.values.CompanyprogressDetail)
                              }}
                            >
                              <VisibilityIcon />
                            </IconButton>
                          )}
                        </div>
                        <div className={classes.flexRow}>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                name="Companyprogress2"
                                checked={
                                  formik.values?.Companyprogress2 === true || formik.values?.Companyprogress2 === 'True'
                                }
                                onClick={() => {
                                  formik.setFieldValue(
                                    "Companyprogress2",
                                    !formik.values?.Companyprogress2
                                  );
                                }}
                              />
                            }
                            style={{ display: 'flex', flex: 1 }}
                            label={"2. Having registered a company"}
                          />
                          <TextField
                            variant="outlined"
                            className={classes.textField}
                            style={{ display: 'flex', flex: 1 }}
                            placeholder="Company Registration Number"
                            name={`CompanyprogressDetail2`}
                            value={formik.values.CompanyprogressDetail2}
                            disabled={formik.values?.Companyprogress2 !== true && formik.values?.Companyprogress2 !== 'True'}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `CompanyprogressDetail2`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `CompanyprogressDetail2`,
                              formik
                            )}
                          />
                        </div>
                        <div className={classes.flexRow}>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                name="Companyprogress3"
                                checked={
                                  formik.values?.Companyprogress3 === true || formik.values?.Companyprogress3 === 'True'
                                }
                                onClick={() => {
                                  formik.setFieldValue(
                                    "Companyprogress3",
                                    !formik.values?.Companyprogress3
                                  );
                                }}
                              />
                            }
                            style={{ display: 'flex', flex: 1 }}
                            label={"3. Having applied for BOI promotion"}
                          />
                          <TextField
                            variant="outlined"
                            className={classes.textField}
                            style={{ display: 'flex', flex: 1 }}
                            placeholder="Application number for BOI promotion"
                            name={`CompanyprogressDetail3`}
                            disabled={formik.values?.Companyprogress3 !== true && formik.values?.Companyprogress3 !== 'True'}
                            value={formik.values.CompanyprogressDetail3}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `CompanyprogressDetail3`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `CompanyprogressDetail3`,
                              formik
                            )}
                          />
                        </div>



                        <InputLabel style={{ marginLeft: 30 }}>
                          * Prerequisite for visa extension
                        </InputLabel>

                      </FormGroup>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colSpan={5}>
                  <div className={classes.cellContent}>
                    <Bagde number={2} />
                    <InputLabel>
                      Name of your stakeholders whom you have already contacted.
                    </InputLabel>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRowHead>
                <StyledTableCell>Name</StyledTableCell>
                <StyledTableCell>Company/Organization</StyledTableCell>
                <StyledTableCell>Position</StyledTableCell>
                <StyledTableCell colSpan={2}>
                  Contact detail
                  <br />
                  (e.g. E-mail or phone number)
                </StyledTableCell>
              </TableRowHead>

              {Stakeholders.map((stakeholders, index) => {
                if (!stakeholders.Status) return null;

                return (
                  <TableRow key={index}>
                    <StyledTableCell>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <TextField
                            variant="outlined"
                            className={classes.textField}
                            name={`stakeholders.${index}.Name`}
                            value={formik.values.stakeholders[index]?.Name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `stakeholders.${index}.Name`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `stakeholders.${index}.Name`,
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <TextField
                            variant="outlined"
                            className={classes.textField}
                            name={`stakeholders.${index}.Company`}
                            value={formik.values.stakeholders[index]?.Company}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `stakeholders.${index}.Company`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `stakeholders.${index}.Company`,
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <TextField
                            variant="outlined"
                            className={classes.textField}
                            name={`stakeholders.${index}.Position`}
                            value={formik.values.stakeholders[index]?.Position}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `stakeholders.${index}.Position`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `stakeholders.${index}.Position`,
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <TextField
                            variant="outlined"
                            className={classes.textField}
                            name={`stakeholders.${index}.ContactDetail`}
                            value={
                              formik.values.stakeholders[index]?.ContactDetail
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `stakeholders.${index}.ContactDetail`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `stakeholders.${index}.ContactDetail`,
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>
                      <IconButton
                        style={{ width: 40, color: theme.palette.error.main }}
                        size="small"
                        onClick={async () => {
                          if (
                            get(
                              formik.values,
                              `stakeholders.${index}.stakeholdersId`,
                              ""
                            )
                          ) {
                            formik.setFieldValue(
                              `stakeholders.${index}.Status`,
                              false
                            );
                          } else {
                            formik.setFieldValue(
                              "stakeholders",
                              Stakeholders.filter((__, i) => i !== index)
                            );
                          }
                        }}
                      >
                        <DeleteForeverIcon />
                      </IconButton>
                      <FormHelperText error={false}> </FormHelperText>
                    </StyledTableCell>
                  </TableRow>
                );
              })}

              <TableRow>
                <StyledTableCell colSpan={5}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <AddRowButton
                      onClick={() => {
                        formik.setFieldValue("stakeholders", [
                          ...Stakeholders,
                          mapStakeholders(defaultStakeholders),
                        ]);
                      }}
                    />
                  </div>
                </StyledTableCell>
              </TableRow>

              {configField.map(field => {
                if (field.subTitle) {
                  return (
                    <React.Fragment key={field.fieldName}>
                      <TableRow>
                        <StyledTableCell colSpan={5}>
                          <div className={classes.cellContent}>
                            <Bagde number={field.number} />
                            <InputLabel>{field.title}</InputLabel>
                          </div>
                        </StyledTableCell>
                      </TableRow>
                      <TableRow >
                        <StyledTableCell colSpan={5}>
                          <div className={classes.cellContent}>
                            <Bagde number={0} />
                            <div className={classes.wrapField}>
                              <InputLabel>{field.subTitle}</InputLabel>
                              <TextField
                                type="number"
                                variant="outlined"
                                className={classes.textField}
                                name={field.fieldName}
                                value={formik.values[field.fieldName]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={isError(field.fieldName, formik)}
                                helperText={getErrorMessage(
                                  field.fieldName,
                                  formik
                                )}
                                multiline
                                rows={5}
                                rowsMin={5}
                                rowsMax={5}
                              />
                            </div>
                          </div>
                        </StyledTableCell>
                      </TableRow>
                    </React.Fragment>
                  )
                }
                return <TableRow key={field.fieldName}>
                  <StyledTableCell colSpan={5}>
                    <div className={classes.cellContent}>
                      <Bagde number={field.number} />
                      <div className={classes.wrapField}>
                        <InputLabel>{field.title}</InputLabel>
                        <TextField
                          variant="outlined"
                          className={classes.textField}
                          name={field.fieldName}
                          value={formik.values[field.fieldName]}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError(field.fieldName, formik)}
                          helperText={getErrorMessage(
                            field.fieldName,
                            formik
                          )}
                          multiline
                          rows={5}
                          rowsMin={5}
                          rowsMax={5}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <ButtonController
isExtend
onClickSaveDraft={() => {
  onSaveDraft();
}}
/>
      </form>
    </div >
  );
}




